import { Decimal } from 'decimal.js';
import { fToLocalNumber } from '@web/utils';
import { VolumeDiscount } from '../types';

type Props = {
  volumeDiscounts: VolumeDiscount[];
  unit?: string | null;
  amount: number;
};

const VolumeDiscounts: React.FC<Props> = (props) => {
  const { volumeDiscounts, unit, amount } = props;

  const getVolumeDiscountLabel = (
    volumeDiscount: VolumeDiscount,
    nextDiscount?: VolumeDiscount,
  ): string => {
    const fromQuantity = new Decimal(volumeDiscount.fromQuantity).toNumber();

    if (!nextDiscount) {
      // If this is the last tier, show format "750+ kg"
      return `${fToLocalNumber(fromQuantity)}+ ${unit ?? ''}`;
    }

    // If there's a next discount tier, show range with next tier's fromQuantity
    const toQuantity = new Decimal(nextDiscount.fromQuantity)
      .minus(1)
      .toNumber();
    return `${fToLocalNumber(fromQuantity)} - ${fToLocalNumber(toQuantity)} ${
      unit ?? ''
    }`;
  };
  const getVolumeDiscountValue = (volumeDiscount: VolumeDiscount): string => {
    return `${volumeDiscount.basePrice} € / ${amount ?? ''}${unit ?? ''}`;
  };

  const sortedDiscounts = [...volumeDiscounts].sort(
    (a, b) =>
      new Decimal(a.fromQuantity).toNumber() -
      new Decimal(b.fromQuantity).toNumber(),
  );

  return (
    <div className="mb-2-0">
      {sortedDiscounts.map((discount, index) => (
        <div
          key={discount.id}
          className="text-body1 flex flex-row justify-between border-b border-primary-border p-1-0"
        >
          <p className="text-body1">
            {getVolumeDiscountLabel(discount, sortedDiscounts[index + 1])}
          </p>
          <p className="font-bd">{getVolumeDiscountValue(discount)}</p>
        </div>
      ))}
    </div>
  );
};

export default VolumeDiscounts;
